"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../globals/uris");
const control_1 = require("../model/control");
const ramp_1 = require("../util/ramp");
exports.UNAVAILABLE = "unavailable";
exports.CALIBRATING = "calibrating";
/**
 * Sensor controls that read their values from sensors.
 */
class SensorControl extends control_1.Control {
    constructor(uri, typeUri, store) {
        super(uri, typeUri, typeUri, store);
        this.status = exports.UNAVAILABLE;
    }
    setSensor(sensor) {
        this.sensor = sensor;
    }
    getSensor() {
        return this.sensor;
    }
    getStatus() {
        return this.status;
    }
    getReferenceValue() {
        return this.referenceValue;
    }
    setReferenceAverageOf(count) {
        this.referenceAverageOf = count;
        this.resetReferenceValueAndAverage();
    }
    setAverageOf(count) {
        this.averageOf = count;
        this.resetReferenceValueAndAverage();
    }
    setSmooth(smooth) {
        if (smooth) {
            this.ramp = new ramp_1.Ramp();
        }
        else {
            this.ramp = undefined;
        }
    }
    resetReferenceValueAndAverage() {
        this.referenceValue = undefined;
        this.resetValue();
        this.status = exports.UNAVAILABLE;
        this.previousValues = [];
    }
    startUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            var freq = yield this.store.findControlParamValue(this.uri, uris_1.AUTO_CONTROL_FREQUENCY);
            if (!freq)
                freq = 100;
            if (this.sensor) {
                this.subscription = this.sensor.watch
                    .auditTime(freq)
                    .subscribe(data => this.setValue(data));
            }
            else {
                console.log(this.uri + " " + exports.UNAVAILABLE);
            }
        });
    }
    update(newValue) {
        this.status = exports.CALIBRATING;
        //still measuring reference value
        if (this.referenceAverageOf && this.previousValues.length < this.referenceAverageOf) {
            this.previousValues.push(newValue);
            //done collecting values. calculate average and adjust previous values
            if (this.previousValues.length == this.referenceAverageOf) {
                this.referenceValue = this.getAverage(this.previousValues);
                this.previousValues = this.previousValues.map(a => a - this.referenceValue);
            }
            //done measuring. adjust value if initialvalue taken
        }
        else {
            //take value relative to referenceValue (optional)
            if (this.referenceValue) {
                newValue -= this.referenceValue;
            }
            //take average of last averageOf values (optional)
            if (this.averageOf) {
                this.previousValues.push(newValue);
                //remove oldest unneeded values
                while (this.previousValues.length > this.averageOf) {
                    this.previousValues.shift();
                }
                //calculate average
                if (this.previousValues.length == this.averageOf) {
                    newValue = this.getAverage(this.previousValues);
                }
            }
            //update via smoothing ramp (optional)
            if (this.ramp) {
                var now = Date.now();
                var duration;
                if (!this.previousUpdateTime) {
                    duration = 1000; //one second initially
                }
                else {
                    duration = now - this.previousUpdateTime;
                }
                this.startUpdateRamp(newValue, duration);
                this.previousUpdateTime = now;
            }
            else {
                //call regular super method
                this.updateValue(newValue);
            }
        }
    }
    getAverage(list) {
        var sum = list.reduce((a, b) => a + b);
        return sum / list.length;
    }
    startUpdateRamp(targetValue, duration) {
        return __awaiter(this, void 0, void 0, function* () {
            var frequency = yield this.store.findControlParamValue(this.uri, uris_1.AUTO_CONTROL_FREQUENCY);
            this.ramp.startOrUpdate(targetValue, duration, frequency ? frequency : 100, value => {
                //call regular super method
                this.updateValue(value);
            });
        });
    }
    reset() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
            this.resetReferenceValueAndAverage();
            /*if (this.resetFunction) {
                this.resetFunction();
            }*/
        }
    }
}
exports.SensorControl = SensorControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/sensorcontrol.js
// module id = 410
// module chunks = 3